import React,{useState, useCallback, useEffect,useRef} from 'react';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import ReplyIcon from '@material-ui/icons/Reply';
import FaceIcon from '@material-ui/icons/Face';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Modal from '@material-ui/core/Modal';
import {Styles} from './Styles';
import {Song} from './Inc';
import {Tools} from './Tools';
import Haiku from './Haiku';
import Tanka from './Tanka';
import HaikuShow from './HaikuShow';
import TankaShow from './TankaShow';
import Ajax from './Ajax';
//import Loading from './Loading';

interface Props {
    userId:string,
}

let maxId = 0;
let minId = 0;
let tid:any;
let isWaiting = false;
let modalPage = "";
let selectedSong:Song;
let stars:{[key:number]:boolean;} = {};
let updateCount = 0;
let isLock = false;
const memoryLimit = 300;

const Main = (props:Props)=> {
    Ajax.setUserId(props.userId);
    const classes = Styles.base();
    const defaultSongs:Song[] = [];
    const [songs,setSongs] = useState(defaultSongs);

    const [isModalOpen,setIsModalOpen] = useState(false);

    const refSongs = useRef(songs);
    useEffect(() => {
      refSongs.current = songs;
    }, [songs]);

    const loadOld = useCallback(()=>{
        isWaiting = true;
        Ajax.send("song/list",{minId:minId},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                if( res.songs.length>0 ){
                    stars = Object.assign(stars, res.stars);
                    if( maxId===0 || maxId<res.songs[0].id ){
                        maxId = res.songs[0].id;
                    }
                    if( minId===0 || minId>res.songs[ res.songs.length-1 ].id ){
                        minId = res.songs[ res.songs.length-1 ].id;
                    }
                    if( refSongs.current.length>0 ){
                        setSongs(refSongs.current.concat(res.songs));
                    } else {
                        setSongs(res.songs);
                    }
                }
            }
            isWaiting = false;
        })
    },[]);

    const loadNew = useCallback(()=>{
        if(isWaiting){
            return;
        }
        isWaiting = true;
        Ajax.send("song/list",{maxId:maxId},(res:any)=>{
            if( res.ok ){
                if( res.songs.length>0 ){
                    stars = Object.assign(stars, res.stars);
                    if( maxId===0 || maxId<res.songs[0].id ){
                        maxId = res.songs[0].id;
                    }
                    setSongs(res.songs.concat(refSongs.current).slice(0,memoryLimit));
                }
            }
            isWaiting = false;
        })
    },[]);

    const refresh = useCallback(()=>{
        Ajax.send("song/points",{maxId:maxId,minId:minId},(res:any)=>{
            //console.log("refresh",res);
            if( res.ok ){
                let newSongs:Song[] = [];
                for( let i=0 ; i<refSongs.current.length ; i++ ){
                    if( res.points[refSongs.current[i].id] ){
                        newSongs.push( {...refSongs.current[i],"point":res.points[refSongs.current[i].id]} );
                    } else {
                        newSongs.push( refSongs.current[i] );
                    }
                }
                setSongs(newSongs);
            }
        });
    },[]);

    const addStar = useCallback( (song:Song,index:number)=>{
        Ajax.send("star/add",{songId:song.id},(res:any)=>{
            //console.log( res );
            if( res.ok ){
                if(stars[song.id]){
                    stars[song.id] = false;
                    if( song.point===1 ){
                        song.point = 0;
                        refSongs.current[index] = song;
                        setSongs(refSongs.current);
                    }
                } else {
                    stars[song.id] = true;
                }
                updateCount = 5;
                refresh();
            }
        });
    },[refresh]);

    const more = ()=>{
        loadOld();
    }
    const startTimer = useCallback(()=>{
        tid = setInterval( ()=>{
            //console.log("timer");
            if( !isLock ){
                isLock = true;
                if( updateCount===0 ){
                    loadNew();
                } else if( updateCount===5 ){
                    refresh();
                }
                updateCount++;
                if( updateCount===10 ){
                    updateCount=0;
                }
                isLock = false;
            }
        },1000);
    },[loadNew,refresh]);
    const stopTimer = ()=>{
        clearInterval(tid);
    }
	const handleModalClose = ()=>{
		modalPage = "";
		setIsModalOpen(false);
    };
    const openHaiku = ()=>{
        modalPage = "haiku";
        setIsModalOpen(true);
    }
    const openTanka = (song:Song)=>{
        selectedSong = song;
        modalPage = "tanka";
        setIsModalOpen(true);
    }
    const openShow = (song:Song)=>{
        selectedSong = song;
        if( song.typeId==="1" ){
            modalPage = "tankashow";
        } else {
            modalPage = "haikushow";
        }
        setIsModalOpen(true);
    }
    const closeHaiku = ()=>{
        updateCount = 0;
        handleModalClose();
    }
    const closeTanka = ()=>{
        updateCount = 0;
        handleModalClose();
        refresh();
    }
    const timeline = ()=>{
        if(!songs || songs.length===0){
            return (null);
        }
        return songs.map( (song:Song,index:number)=>{
            const key = song.id;
            let classname = classes.songBox + " ";
            if( song.typeId==="1" ){
                //classname += classes.tanka;
            }
            if( song.typeId==="2" ){
                //classname += classes.haiku;
            }
            //console.log(song);

            let starIcon;
            if( stars[song.id] ){
                starIcon = (
                    <StarIcon className={classes.iconStarChecked}/>
                );
            } else {
                starIcon = (
                    <StarBorderIcon className={classes.iconStar}/>
                );
            }

            return (
                <div key={key} className={classname}>
                    <div className={classes.songStatus} style={{textAlign:"center"}}>
                        {song.typeId==="2" ? (
                            song.userId!==props.userId ? (
                                <Fab size="small" color="secondary" onClick={()=>openTanka(song)}><ReplyIcon/></Fab>
                            ):(
                                <Fab size="small" color="primary" onClick={()=>openShow(song)}><FaceIcon/></Fab>
                            )
                        ):(
                            song.userId!==props.userId ? (
                                <Fab size="small" color="primary" onClick={()=>addStar(song,index)}>{starIcon}</Fab>
                            ):(
                                <Fab size="small" color="primary" onClick={()=>openShow(song)}><FaceIcon/></Fab>
                            )
                        )}
                        <Chip size="small" label={song.point}/>
                    </div>
                    <div className={classes.songLines}>
                        {song.words1}<br/>
                        {song.words2}<br/>
                        {song.words3}<br/>
                        {song.typeId==="1" &&
                            <React.Fragment>
                            {song.words4}<br/>
                            {song.words5}<br/>
                            </React.Fragment>
                        }
                    </div>
                </div>
            )
        });
    }

    useEffect( ()=>{
        //console.log("enter");
        loadOld();
        startTimer();
        return ()=>{
            //console.log("leave");
            minId = 0;
            maxId = 0;
            stopTimer();
        }
    },[loadOld,startTimer]);

    let isMore = true;
    if( minId===1 || songs.length>=memoryLimit ){
        isMore = false;
    }

	return (
		<div id="main" className={classes.mainRoot}>
            <div className={classes.timeline}>
                {timeline()}
                {isMore &&
                <Button variant="text" color="primary" style={{marginBottom:"2em",width:"100%"}} onClick={more}><ArrowDropDownIcon/></Button>
                }
            </div>
            <Tooltip title="ハイクを作る">
                <Fab color="secondary" aria-label="Add" className={classes.fabAddHaiku} onClick={openHaiku}>
                    <AddIcon/>
                </Fab>
            </Tooltip>
			<Modal
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				open={isModalOpen}
				onClose={handleModalClose}
			>
				<div style={Tools.getModalStyle()} className={classes.modal}>
                    {modalPage==="haiku" &&
                    <Haiku userId={props.userId} close={closeHaiku}/>
                    }
                    {modalPage==="tanka" &&
                    <Tanka userId={props.userId} close={closeTanka} haiku={selectedSong}/>
                    }
                    {modalPage==="haikushow" &&
                    <HaikuShow userId={props.userId} close={handleModalClose} song={selectedSong}/>
                    }
                    {modalPage==="tankashow" &&
                    <TankaShow userId={props.userId} close={handleModalClose} song={selectedSong} hasStar={false}/>
                    }

	    		</div>
			</Modal>

		</div>
	);
}

export default Main;
